function initUpload() {
  const upload = document.querySelector('.upload');
  if (!upload) {
    return;
  }

  const uploadList = upload.querySelector('.upload__list');
  const uploadInput = upload.querySelector('.upload__input');
  const uploadZone = upload.querySelector('.upload__zone');
  const uploadAlert = upload.querySelector('.upload__alert');
  const generateBtn = document.querySelector('.workspace__generate');

  const checkFiles = () => {
    const hasErrors = uploadList.querySelector('.is-error');

    upload.classList.toggle('is-filled', uploadList.children.length > 0);
    uploadAlert.classList.toggle('is-active', !!hasErrors);

    if (generateBtn) {
      generateBtn.classList.toggle('is-disabled', !!hasErrors);
    }
  };

  const addFiles = (files) => {
    Array.from(files).forEach((file) => {
      const ext = file.name.split('.').pop();
      const sizeMb = file.size / 1024 / 1024;
      const size = sizeMb < 1 ? Math.round(file.size / 1024) + ' КБ' : Math.round(sizeMb) + ' МБ';
      let error = '';

      if (ext.toLowerCase() === 'zip') {
        error = 'Формат ZIP не поддерживается';
        uploadAlert.querySelector('p').textContent = 'Формат ZIP не поддерживается. Удалите файл или загрузите другой';
      } else if (sizeMb > 100) {
        error = 'Файл превышает лимит в 100 МБ. Вес файла ' + size;
        uploadAlert.querySelector('p').textContent = 'Файл превышает лимит в 100 МБ. Удалите его или загрузите другой';
      }

      const card = document.createElement('li');
      card.className = error ? 'file-card is-error' : 'file-card is-loading';
      card.innerHTML = `
        <span class="file-card__type">${error ? '!' : ext}</span>
        <div class="file-card__info">
          <p class="file-card__name">${file.name}</p>
          <p class="file-card__meta">${error || 'Загрузка...'}</p>
          <span class="file-card__bar"></span>
        </div>
        <button class="file-card__remove" type="button" aria-label="Убрать файл"></button>
      `;
      uploadList.append(card);

      if (!error) {
        setTimeout(() => {
          card.classList.remove('is-loading');
          card.querySelector('.file-card__meta').textContent = size;

          if (upload.dataset.next && !uploadList.querySelector('.is-loading, .is-error')) {
            window.location.href = upload.dataset.next;
          }
        }, 1500);
      }
    });

    checkFiles();
  };

  uploadInput.addEventListener('change', () => {
    addFiles(uploadInput.files);
    uploadInput.value = '';
  });

  uploadZone.addEventListener('dragover', (e) => {
    e.preventDefault();
  });

  uploadZone.addEventListener('drop', (e) => {
    e.preventDefault();
    addFiles(e.dataTransfer.files);
  });

  uploadList.addEventListener('click', (e) => {
    if (e.target.classList.contains('file-card__remove')) {
      e.target.closest('.file-card').remove();
      checkFiles();
    }
  });
}

export {initUpload};
